module.exports = __webpack_public_path__ + "1a3ffb81d71eebbf49390effa6f3d270.svg";


//////////////////
// WEBPACK FOOTER
// ./components/verifications/fail/error-illustration.svg
// module id = 1095
// module chunks = 0